import { useContext } from 'react';
import LoadingContext from './LoadingContext';

export const useLoading = () => {
    const toggleLoading = useContext(LoadingContext);
    return toggleLoading;
};
